const moment = require('moment');
/**
	* 単純なサンプル
	* moment.jsを使って現在日付をconsole出力するだけ
	*/
$(function () {
	console.log(moment().format("YYYY-MM-DD"));
});

// オプションを指定する。
const options = {
	rootMargin: "-50% 0px",
	threshold: [0, 1.0]
}

const observer = new IntersectionObserver((entries) => {
	for (const e of entries) {
		// console.log(e.target.id);
		// console.log(e.intersectionRatio);
		$("#nav li").removeClass("active");
		$("#nav li[rel='" + e.target.id + "']").addClass("active");
	}
}, options);
/*
const optionsFirst = {
	rootMargin: "100px 0px",
	threshold: [0, 1.0]
}

const observerFirst = new IntersectionObserver((entries) => {
	for (const e of entries) {
		// console.log(e.target.id);
		console.log(e.intersectionRatio);
		$("#nav li").removeClass("active");
		$("#nav li[rel='toppage__section1']").addClass("active");
	}
}, optionsFirst);
*/

observer.observe(document.querySelector('#toppage__section12'));
observer.observe(document.querySelector('#toppage__section11'));
observer.observe(document.querySelector('#toppage__section10'));
observer.observe(document.querySelector('#toppage__section9'));
observer.observe(document.querySelector('#toppage__section8'));
observer.observe(document.querySelector('#toppage__section7'));
observer.observe(document.querySelector('#toppage__section6'));
observer.observe(document.querySelector('#toppage__section5'));
observer.observe(document.querySelector('#toppage__section4'));
observer.observe(document.querySelector('#toppage__section3'));
observer.observe(document.querySelector('#toppage__section2'));
observer.observe(document.querySelector('#toppage__section1'));


$(window).on('scroll', function () {
	var _nav = $('#nav');
	var _interviewTop = $('.toppage__wrap').offset().top;
	var _footerTop = $('.footer').offset().top;
	var _windowTop = $(window).scrollTop();
	var _windowHeight = $(window).innerHeight();
	if (_windowTop > _interviewTop) {
		_nav.addClass('fixed');
		var margin = 0;
		var left = $('.toppage__wrap').offset().left;
		_nav.css({ 'top': margin + 'px', 'left': left + 'px' });
	} else {
		_nav.removeClass('fixed').removeAttr('style');
	}
	if (_windowTop + _windowHeight > _footerTop) {
		_nav.addClass('hide')
	} else {
		_nav.removeClass('hide')
	}
})
